import React from "react";
import "./FarewellMessage.css";

const FarewellMessage = () => {
  return (
    <div className="farewell-container">
      <div className="farewell-content">
        <h2 className="farewell-text">See you soon...</h2>
        <div className="farewell-image-container">
          <img
            src="/boardwalkLeavingEnhanced.jpg"
            alt="Boardwalk leaving view"
            className="farewell-image"
          />
        </div>
      </div>
    </div>
  );
};

export default FarewellMessage;
